import script from "./sales.vue?vue&type=script&setup=true&lang=js"
export * from "./sales.vue?vue&type=script&setup=true&lang=js"

import "./sales.vue?vue&type=style&index=0&id=1f250334&lang=scss&scoped=true"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f250334"]])

export default __exports__